import React, { FC, ReactNode, useContext } from 'react';
import { Container } from '@fiverr-private/layout_components';
import { DocumentLegalDocsIcon } from '@fiverr-private/visuals';
import { Link } from '@fiverr-private/typography';
import { ComplianceContext } from '../ComplianceProvider';
import { ComplianceType, ComplianceTypes } from '../ComplianceModal/types';
import { reportEventsApi } from '../../biEvents';

export const LegalDocsSection = (
    redirectUrl: string | undefined,
    requeseteeId: number,
    requeseteeUserName: string
): {
    icon: React.ReactNode;
    complianceType: ComplianceType;
    Wrapper: FC<{
        children: ReactNode;
    }>;
}[] => {
    const complianceContext = useContext(ComplianceContext);

    return [
        {
            icon: <DocumentLegalDocsIcon size={'md'} color={'grey_1200'} />,
            complianceType: ComplianceTypes.LEGAL_DOCS,
            Wrapper: ({ children }: { children: React.ReactNode }) => (
                <Container width="100%">
                    <Link
                        cursor="pointer"
                        href={redirectUrl}
                        onClick={() => {
                            if (complianceContext) {
                                if (
                                    complianceContext.getSellerComplianceState(requeseteeId)?.legalDocsData
                                        ?.totalTemplates
                                ) {
                                    reportEventsApi.clickedOnSendDocument({ pageName: complianceContext.pageName });
                                } else {
                                    reportEventsApi.clickOnLegalDocument({
                                        pageName: complianceContext.pageName,
                                        type: 'section',
                                    });
                                }
                            }

                            if (!redirectUrl) {
                                complianceContext?.openSendLegalDocsModal({
                                    sellerName: requeseteeUserName,
                                    sellerId: requeseteeId,
                                });
                            }
                        }}
                        target="_blank"
                        rel="noreferrer"
                        decoration="none"
                    >
                        {children}
                    </Link>
                </Container>
            ),
        },
    ];
};
